import type { EventLogEntry } from '../../../../types/council';

/** The live council roster wire shape is snake_case (get_council_state returns it
 *  verbatim; CouncilContext reads `persona_id` directly). The camelCase
 *  `CouncilRosterEntry` TS interface does NOT match runtime — the cockpit reads the
 *  wire shape ("snake_case wire verbatim", matching the G4b cost convention). */
export interface CockpitRosterEntry {
  persona_id: string;
  role?: string;
  mode?: string;
  dismissed_at?: string | null;
  daily_loop_budget?: number;
  daily_loop_count?: number;
  spine_root_message_id?: string | null;
}

export function maxCascadeDepth(entries: EventLogEntry[]): number {
  let m = 0;
  for (const e of entries) if (typeof e.cascade_depth === 'number' && e.cascade_depth > m) m = e.cascade_depth;
  return m;
}

export function depthDistribution(entries: EventLogEntry[]): Map<number, number> {
  const out = new Map<number, number>();
  for (const e of entries) {
    if (e.event_type !== 'turn_added') continue;
    const d = e.cascade_depth ?? 0;
    out.set(d, (out.get(d) ?? 0) + 1);
  }
  return out;
}

export function mostConstrainedPeer(
  roster: CockpitRosterEntry[],
): { personaId: string; loopFrac: number } | null {
  let best: { personaId: string; loopFrac: number } | null = null;
  for (const p of roster) {
    if (p.dismissed_at) continue;
    const budget = p.daily_loop_budget ?? 0;
    const frac = budget > 0 ? (p.daily_loop_count ?? 0) / budget : 0;
    if (!best || frac > best.loopFrac) best = { personaId: p.persona_id, loopFrac: frac };
  }
  return best;
}
